/**
 * 通用订单管理API服务
 * @description 只包含纯API调用函数，不包含业务逻辑和格式化函数
 */

import { get, post, put, patch, del } from './request';
import type { PaginatedData } from './typings';
import type {
  Order,
  OrderListParams,
  OrderStatistics,
  OrderStatusUpdateRequest,
  BatchOrderOperationRequest,
} from './orders.d';

// ============= 订单查询 =============

/**
 * 获取订单列表
 */
export async function getOrders(params?: OrderListParams) {
  return get<PaginatedData<Order>>('/api/tenant/orders', {
    params: {
      page: 1,
      per_page: 20,
      ...params,
    },
  });
}

/**
 * 获取订单详情
 */
export async function getOrderDetail(orderId: number) {
  return get<Order>(`/api/tenant/orders/${orderId}`);
}

/**
 * 获取订单统计数据
 */
export async function getOrderStatistics(params?: {
  start_date?: string;
  end_date?: string;
  platform?: string;
}) {
  return get<OrderStatistics>('/api/tenant/orders/statistics', {
    params,
  });
}

// ============= 订单操作 =============

/**
 * 创建订单
 */
export async function createOrder(data: Partial<Order>) {
  return post<Order>('/api/tenant/orders', data);
}

/**
 * 更新订单
 */
export async function updateOrder(orderId: number, data: Partial<Order>) {
  return put<Order>(`/api/tenant/orders/${orderId}`, data);
}

/**
 * 更新订单状态
 */
export async function updateOrderStatus(
  orderId: number,
  data: OrderStatusUpdateRequest,
) {
  return patch<Order>(`/api/tenant/orders/${orderId}/status`, data);
}

/**
 * 删除订单
 */
export async function deleteOrder(orderId: number) {
  return del(`/api/tenant/orders/${orderId}`);
}

// ============= 批量操作 =============

/**
 * 批量更新订单状态
 */
export async function batchUpdateOrderStatus(data: BatchOrderOperationRequest) {
  return patch('/api/tenant/orders/batch/status', data);
}

/**
 * 批量导出订单
 */
export async function exportOrders(params?: {
  order_ids?: number[];
  format?: 'csv' | 'xlsx';
  filters?: OrderListParams;
}) {
  return post('/api/tenant/orders/export', params);
}


